"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var usePersistFn_1 = __importDefault(require("../usePersistFn"));

var utils_1 = require("../utils");

var useUnmount = function useUnmount(fn) {
  var fnPersist = usePersistFn_1["default"](fn);
  react_1.useEffect(function () {
    return function () {
      if (utils_1.isFunction(fnPersist)) {
        fnPersist();
      }
    };
  }, []);
};

exports["default"] = useUnmount;